import img1 from '../assets/a1.jpg';
import img2 from '../assets/a2.jpg';
import imgu1 from '../assets/u1.jpg';
// import imgu2 from '../assets/u2.webp';
import imgu10 from '../assets/u10.jpg';
import imgu11 from '../assets/u11.jpg';
import imgu12 from '../assets/u12.jpg';
import imgu13 from '../assets/u13.jpg';
import imgu3 from '../assets/u3.jpg';
import imgu4 from '../assets/u4.jpg';
import imgu5 from '../assets/u5.jpg';
import imgu9 from '../assets/u9.jpg';
import imgu6 from '../assets/uc6.jpg';
import imgu7 from '../assets/uc7.jpg';
import imgu8 from '../assets/uc8.jpg';
import lina from '../assets/lina.jpg';
import maya from '../assets/maya.jpg';
import sophie from '../assets/sophie.jpg';
import img3 from '../assets/a3.jpg';
import img111 from "../assets/aa.jpg";
import img4 from '../assets/b1.jpg';
import img5 from '../assets/b2.jpg';
import img6 from '../assets/b3.jpg';
import img7 from '../assets/b4.jpg';
import img8 from '../assets/b5.jpg';
import img9 from '../assets/b6.jpg';
import img22 from "../assets/bb.jpg";
import img10 from '../assets/c1.jpg';
import img11 from '../assets/c2.jpg';
import img12 from '../assets/c3.jpg';
import img13 from '../assets/c4.jpg';
import img33 from "../assets/cc.jpg";
import img44 from "../assets/dd.jpg";


export const DUMMY_PROFILES = [
  { id: 1, name: 'Sophia', role: 'Model', location: 'Paris', price: 300, img: img111 },
  { id: 2, name: 'Isabella', role: 'Dancer', location: 'Madrid', price: 350, img: img22 },
  { id: 3, name: 'Emma', role: 'Student', location: 'Berlin', price: 250, img: img33 },
  { id: 4, name: 'Olivia', role: 'Actress', location: 'Milan', price: 400, img: img44 }
];




export const upperSliderImages = [
  { img: imgu1, para: "Sofia Rossi" },
  // { img: imgu2, para: "Eva Müller" },
  { img: imgu3, para: "Lara Novak" },
  { img: imgu4, para: "Elena Petrova" },
  { img: imgu5, para: "Amelie Dubois" },
  { img: imgu10, para: "Chiara Romano" },
  { img: imgu11, para: "Ingrid Hansen" },
  { img: imgu6, para: "Marta Silva" },
  { img: imgu7, para: "Klara Schmidt" },
  { img: imgu12, para: "Olga Ivanova" },
  { img: imgu8, para: "Isabelle Laurent" },
  { img: imgu9, para: "Zara Popescu" },
  { img: imgu13, para: "Anya Volkova" },
];




export const sliderImages = [
  {
    img: img1,
    para: "Doll For Male Full Sex"
  },
  { img: img2, para: "Adult Male Love Doll" }, { img: img3, para: "Life Like Sex Doll" },
  { img: img12, para: "Ultimate Full Sex Doll" },
  { img: img4, para: "Silicone Doll For Men" }, { img: img5, para: "Luxury Adult Sex Doll" },

  { img: img10, para: "Sexy Silicone Male Doll" },
  { img: img11, para: "Luxury Male Love Doll" },

  { img: img6, para: "Ultimate Male Pleasure Doll" }, { img: img7, para: "Hot Male Sex Doll" },
  { img: img13, para: "Lifelike Male Pleasure Doll" },

  { img: img8, para: "Premium Realistic Sex Doll" }, { img: img9, para: "Realistic Adult Toy Doll" },
];

export const stories = [
  {
    title: "Maya & Lucas",
    text: `Maya’s bio said: ‘I’m only here for good vibes and bad karaoke.’ Lucas challenged her to a sing-off, and somehow they ended up duetting every weekend since.."`,
    link: "#",
    imgSrc: maya,
  },
  {
    title: "Sophie & Daniel",
    text: `Sophie’s first message was a single pizza emoji 🍕. Daniel replied with a pizza place recommendation — and that’s where their first date (and slice) happened..`,
    link: "#",
    imgSrc: sophie,
  },
  {
    title: "Lina & Omar",
    text: 'Lina’s profile said she loved sunsets and long drives. Omar sent her a playlist for road trips, and now they chase sunsets together every Sunday',
    link: "#",
    imgSrc: lina,
  },
];

// sophie ==> https://www.pinterest.com/pin/260505159691281060/
//  Lina ==> https://www.pinterest.com/pin/581105158209126971/
//  maya ==> https://www.pinterest.com/pin/7810999347717318/
